import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import axios from 'axios';
import { initValues } from '../store';
import { remote } from '../config';
import OrganizationInformation from './sections/OrganizationInfomation';
import BillingInformation from './sections/BillingInformation';
import PersonalInformation from './sections/PersonalInformation';
import OrtherInformation from './sections/OrtherInformation';
import TermsConditions from './sections/TermsConditions';
import RegistrationSchema from '../schema';
import { cleanValues } from '../utils';
import Success from './Success';

const RegistrationForm = () => {
  const [success, setSuccess] = useState(false);
  return (
    <div className='form mx-auto border border-gray-300 px-6 py-4 my-12 shadow'>
      {success && (
        <Success
          title='Thank You!'
          content='Your submission is received and we will contact you soon.'
          buttonUrl='https://business.nus.edu.sg/#courses'
          buttonLabel='Continue to browse more'
        />
      )}
      {!success && (
        <Formik
          enableReinitialize={true}
          initialValues={initValues}
          validationSchema={RegistrationSchema}
          onSubmit={async (values) => {
            try {
              const val = await cleanValues(values);
              const res = await axios.post(remote, val);

              if (res.data.success) {
                setSuccess(true);
              }
            } catch (e) {
              console.log(e);
            }
          }}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <PersonalInformation
                values={values}
                setFieldValue={setFieldValue}
              />
              <OrganizationInformation
                values={values}
                setFieldValue={setFieldValue}
              />
              {values.sponsorship === 1 && (
                <BillingInformation values={values} />
              )}
              <OrtherInformation
                values={values}
                setFieldValue={setFieldValue}
              />
              <TermsConditions values={values} />
              <div>
                <button
                  type='submit'
                  className='mt-4 bg-orange-500 hover:bg-orange-600 text-white py-2 px-6 font-semibold uppercase rounded'
                >
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default RegistrationForm;
